<div class="px-px-24 py-px-16">
    <div class="d-flex justify-content-between align-items-center">
  
      <div class="me-4 inner-add-on left-add-on my-3" [formGroup]="form">
        <input type="search" class="form-control w-px-335"
               formControlName="keyword"
                (input)="searchAgency($event)"
               placeholder="Rechercher une agence"/>
        <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
      </div>
  
      <app-button text="Ajouter une agence" srcIcon="assets/icons/plus.svg"
                  (handleClick)="openAddAgencyDialog()"
      ></app-button>
    </div>
    @if(loading) {
  
    <app-loader ></app-loader>
    } @else {
      <app-data-table
        [dataSource]="filteredAgencyList"
        [columns]="customColumnsAgencyManagement"
        [totalItems]="totalItems"
        (nextPage)="pagination($event)"
        [hasRowAction]="true"
        (rowActionClick)="handleRowClick($event)"
      ></app-data-table>
    }
  
  </div>
  